import {Button, Tree, TreeDataNode} from 'antd';
import {FC, useMemo} from 'react';
import {IKey, IKeyMethods} from '../apis/diaries/diaries';
import './tree.css';

const {DirectoryTree} = Tree;

const monthTextMap: Record<string, string> = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  '10': 'October',
  '11': 'November',
  '12': 'December',
};

export const Index: FC<{
    keys: IKey[], // assert: keys is sorted by desc order
    chosenKey: IKey,
    onChoose: (chosenKey: IKey) => void,
}> = (args) => {
  const treeData = useMemo(() => {
    const t: TreeDataNode[] = [];
    let [lastY, yIdx, lastM, mIdx] = [0, -1, 0, -1];
    args.keys.forEach((k) => {
      const [y, m, d] = IKeyMethods.asStrings(k);
      if (k.Year !== lastY) {
        // new year
        t.push({title: y, key: y, children: []});
        lastY = k.Year;
        yIdx++;
        mIdx = -1;
      }
      if (k.Month !== lastM) {
                // new month
                t[yIdx].children!.push({title: y + '-' + monthTextMap[m], key: y + '-' + m, children: []});
                lastM = k.Month;
                mIdx++;
      }
            t[yIdx].children![mIdx].children!.push({
              title: <Button type="link"
                disabled={IKeyMethods.equal(args.chosenKey, k)}
                onClick={() => {
                  args.onChoose(k);
                }}
                style={{paddingLeft: 0}}
              >
                {y + '-' + m + '-' + d}
              </Button>,
              key: y + '-' + m + '-' + d,
            });
    });
    return t;
  }, [args.keys]);
  const [cy, cm, cd] = IKeyMethods.asStrings(args.chosenKey);
  return <DirectoryTree // directory tree can expand/collapse when click node
    icon={null}
    defaultExpandedKeys={[cy + '-' + cm + '-' + cd]}
    treeData={treeData}
    height={800}
    style={{
      backgroundColor: '#f0f2f5', // this is antd-layout backgroud color, so that looks like transparent
    }}
  />;
};
